angular.module('app').component('reportAccessGrid', {
    templateUrl: 'scripts/app/components/report-access-grid.tpl.html',
    bindings: { reportId: '<', updateState: '=' },
    controllerAs: "vm",
    controller: function (
        $window, $location,
        toastr,
        UserDetails, ReportAccessService) {
        var vm = this;
        $window.vmNavEx = vm;
        vm.data = {
            reportAccessGrid: []
        };

        vm.refresh = refresh;
        // vm.update = update;
        vm.updateModel = updateModel;
        vm.updateList = updateList;

        // Get some lodash available in the template
        vm._ = _;

        vm.$onInit = function () {
            if (this.reportId) {
                vm.reportId = this.reportId;
                vm.updateState = "init";
            }

            vm.path = $location.path();
            UserDetails.get().then(function (user) {
                //console.log(user);
                vm.userDetails = user;
            });
            refresh();
        };
        function refresh() {
            ReportAccessService.getValidRoles().then(function (rolesReponse) {
                vm.data.allRoles = rolesReponse.data;
                // vm.data.allRoles = [rolesReponse.data[0], rolesReponse.data[1]];

                ReportAccessService.getReportAccessGridAsStringList().then(function (gridResponse) {
                    // vm.data.reportAccessList = [gridResponse.data[0]];
                    // vm.data.reportAccessList = gridResponse.data;

                    if (vm.reportId) {
                        // Take the selected report out of the collection.
                        vm.data.reportAccessList = _.remove(gridResponse.data, function (row) { return row.Report.Id == vm.reportId; });

                        // Back up the remaining collection to be submitted later
                        vm.data.fullData = gridResponse.data;
                    }
                    else {
                        vm.data.reportAccessList = gridResponse.data;
                    }


                    // console.log(vm.data.reportAccessList, "reportAccessList");
                });

            });

            // ReportAccessService.getReportAccessGrid().then(function (response) {
            //     // console.log(response.data);
            //     // console.log(vm.data.reportAccessGrid);
            //     if (vm.reportId) {
            //         // if (vm.reportId !== undefined && vm.reportId !== null) {
            //         // Take the selected report out of the collection.
            //         vm.data.reportAccessGrid = _.remove(response.data, function (report) { return report.ReportId == vm.reportId; });

            //         // Back up the remaining collection to be submitted later
            //         vm.data.fullData = response.data;
            //         // console.log(vm.data.fullData);
            //     }
            //     else {
            //         vm.data.reportAccessGrid = response.data;
            //     }
            //     // console.log(vm.data.reportAccessGrid);
            // });
        }

        function updateModel(row, role) {
            
            if (_.includes(row.AssignedRoles, role.Name)) {
                _.remove(row.AssignedRoles, function (assignedRole) {
                    return assignedRole === role.Name;
                });
            }
            else {
                row.AssignedRoles.push(role.Name);
            }
        }

        function updateList() {
            if (vm.reportId) {
                // we need to recombine the selectedreport and the other untouched reports together due to how the api / business logic works. 
                var accessList = _.concat(vm.data.reportAccessList, vm.data.fullData);
                ReportAccessService.saveReportAccessList(accessList).then(function () {
                    vm.updateState = "update";  // This is a dialog - so tell the main page to reload to update report menu 
                });
            }
            else {
                ReportAccessService.saveReportAccessList(vm.data.reportAccessList).then(function () {
                    location.reload();
                });
            }
        }

        // function update() {
        //     if (vm.reportId) {
        //         // we need to recombine the selectedreport and the other untouched reports together due to how the api / business logic works. 
        //         var rag = _.concat(vm.data.reportAccessGrid, vm.data.fullData);
        //         ReportAccessService.saveReportAccessGrid(rag).then(function () {
        //             toastr.info('Report access updated');
        //             vm.updateState = "update";  // This is a dialog - so tell the main page to reload to update report menu 
        //         });
        //     }
        //     else {
        //         ReportAccessService.saveReportAccessGrid(vm.data.reportAccessGrid).then(function () {
        //             location.reload();
        //         });
        //     }
        // }
    }
});
